import { render } from "./manage-footer-paragraph.vue?vue&type=template&id=f62b8498"
import script from "./manage-footer-paragraph.vue?vue&type=script&lang=js"
export * from "./manage-footer-paragraph.vue?vue&type=script&lang=js"

import "./manage-footer-paragraph.vue?vue&type=style&index=0&id=f62b8498&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__